import { render } from "./PasswordEdit.vue?vue&type=template&id=eb1d95dc&scoped=true"
import script from "./PasswordEdit.vue?vue&type=script&lang=js"
export * from "./PasswordEdit.vue?vue&type=script&lang=js"

import "./PasswordEdit.vue?vue&type=style&index=0&id=eb1d95dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1d95dc"]])

export default __exports__